import { EmbedHtmlBlockService } from '@blocksuite/blocks';

export class PiqueQuizEmbedBlockService extends EmbedHtmlBlockService {
  override mounted(): void {
    super.mounted();
    // Add any quiz-specific initialization here
  }
}
